/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var RemoteJobRunStatus;
(function (RemoteJobRunStatus) {
    RemoteJobRunStatus["QUEUED"] = "QUEUED";
    RemoteJobRunStatus["RUNNING"] = "RUNNING";
    RemoteJobRunStatus["FINISHED"] = "FINISHED";
    RemoteJobRunStatus["ERROR"] = "ERROR";
})(RemoteJobRunStatus || (RemoteJobRunStatus = {}));
export function RemoteJobRunStatusFromJSON(json) {
    return RemoteJobRunStatusFromJSONTyped(json, false);
}
export function RemoteJobRunStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function RemoteJobRunStatusToJSON(value) {
    return value;
}
